import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { PenTool, Sparkles, ExternalLink } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BlogAgentCard() {
  const [posts, setPosts] = useState([]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = () => {
    axios.get(`${API}/api/blog/posts?limit=5`).then((r) => setPosts(r.data.posts || [])).catch(() => {});
  };
  useEffect(load, []);

  const generate = async () => {
    setBusy(true);
    setMsg(null);
    try {
      const res = await axios.post(`${API}/api/blog/generate`, null, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setMsg({ ok: true, text: `Published "${res.data.title}" (${res.data.category_label})` });
      load();
    } catch (e) {
      setMsg({ ok: false, text: e.response?.data?.detail || 'Generation failed' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6" data-testid="blog-agent-card">
      <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2 mb-1">
        <PenTool className="h-5 w-5 text-orange-500" /> AI Blog Agent
      </h3>
      <p className="text-sm text-gray-500 mb-4">
        Writes and publishes one SEO article every Wednesday, rotating Homeowner Tips → Contractor Business → Tools & Materials. You get an email each time.
      </p>
      <button
        onClick={generate}
        disabled={busy}
        className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-semibold bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50"
        data-testid="blog-generate-now-btn"
      >
        <Sparkles className="h-4 w-4" /> {busy ? 'Writing article (30-60s)...' : 'Generate Article Now'}
      </button>
      {msg && (
        <p className={`mt-3 text-sm font-semibold ${msg.ok ? 'text-emerald-700' : 'text-red-600'}`} data-testid="blog-generate-result">
          {msg.ok ? '✓ ' : '✗ '}{msg.text}
        </p>
      )}
      {posts.length > 0 && (
        <div className="mt-4 border-t border-gray-100 pt-3" data-testid="blog-recent-posts">
          <p className="text-xs font-semibold uppercase text-gray-400 mb-2">Latest articles ({posts.length})</p>
          <ul className="space-y-1.5">
            {posts.map((p) => (
              <li key={p.slug} className="text-sm flex items-center gap-2">
                <span className="text-[10px] font-bold uppercase bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded shrink-0">{p.category_label}</span>
                <a href={`/blog/${p.slug}`} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline truncate flex items-center gap-1">
                  {p.title} <ExternalLink className="h-3 w-3 shrink-0" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
